import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import FAQSection from "./faqSection"; // keep your FAQ

export default function PricingPage() {
  const navigate = useNavigate();

  const goToCompare = (plan) => {
    navigate(`/pricing/compare?highlight=${plan}`);
  };

  return (
    <div className="flex-grow w-full bg-white py-8 px-6 md:px-16 lg:px-24">

      {/* Page Title */}
      <h1 className="mb-4 text-center">Pricing Plans</h1>
      <p className="text-center text-gray-600 mb-10">
        Simple, transparent pricing — no hidden fees.
      </p>

      {/* PLAYER PRICING */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">

        {/* BASIC */}
        <PriceCard
          name="Basic"
          tagline="For casual players"
          price="Free"
          features={[
            "Access essential tools",
            "View schedules & classes",
            "Suitable for beginners",
          ]}
          onClick={() => goToCompare("free")}
        />

        {/* PRO */}
        <PriceCard
          name="Pro"
          tagline="For active players"
          price="RM 19.90"
          popular
          monthly
          features={[
            "Unlock advanced training tools",
            "Player insights included",
            "Great for improving players",
          ]}
          onClick={() => goToCompare("pro")}
        />

        {/* PREMIUM */}
        <PriceCard
          name="Premium"
          tagline="For competitive athletes"
          price="RM 29.90"
          monthly
          features={[
            "Full access to advanced tools",
            "In-depth performance analytics",
            "Create personal periodisation",
          ]}
          onClick={() => goToCompare("premium")}
        />
      </div>

      {/* Compare Button */}
      <div className="text-center mt-8">
        <button
          onClick={() => goToCompare("")}
          className="flex items-center gap-1 text-blue-600 hover:underline mx-auto"
        >
          Compare all plans <FiChevronRight />
        </button>
      </div>

      {/* COACH SECTION */}
      <div className="max-w-4xl mx-auto mt-16">
        <h1 className="mb-4 text-center">For Coaches</h1>
        <p className="text-center text-gray-600 mb-10">
          Professional tools to manage players, classes, and training.
        </p>

        <div className="max-w-sm mx-auto">
          <PriceCard
            name="Coach"
            tagline="For professional coaches & academies"
            price="RM 34.90"
            monthly
            features={[
              "Full coaching dashboard",
              "Player management tools",
              "Advanced coaching features",
            ]}
          />
        </div>
      </div>

      {/* FAQ */}
      <FAQSection />
    </div>
  );
}

/* PRICE CARD */
const PriceCard = ({ name, tagline, price, monthly, features, onClick, popular }) => (
  <div
    onClick={onClick}
    className={`cursor-pointer relative border rounded-2xl p-6 shadow-sm bg-white flex flex-col
    transition-transform duration-300 hover:scale-[1.03] ${popular && "border-blue-100"}`}
  >
    {popular && (
      <div className="absolute -top-3 left-6 right-6 text-center">
        <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs shadow-md">
          Most Popular
        </span>
      </div>
    )}

    <h2 className="text-xl font-bold text-center mt-4">{name}</h2>
    <p className="text-center text-gray-500 mb-4 text-sm mt-4">{tagline}</p>

    <div className="text-center mb-6">
      <span className="text-4xl font-bold">{price}</span>
      {monthly && <span className="text-gray-600 block text-sm">per month</span>}
    </div>

    <div className="flex-grow mx-auto text-left w-full max-w-[220px]">
      <ul className="space-y-2 text-sm text-gray-700">
        {features.map((f, idx) => (
          <li key={idx}>• {f}</li>
        ))}
      </ul>
    </div>
  </div>
);
